import { GET } from '@/utils/axios'

export const getTheme = async () => {
  console.log('window.location.hostname: ', window.location.hostname)
  const themeName = window.location.hostname.split('.')
  return await GET(`/organization-settings/${themeName[0]}`)
}
